export default "__VITE_ASSET__XsrrbLM2__"